import { FlagsComponentRouter, FlagsSingleton } from 'flags'
import { isHighSchoolUrl, isHighSchoolDashboard } from 'utils/highschoolHelpers'
import {
  isMiddleSchoolUrl,
  isMiddleSchoolDashboard,
  isK5Url,
  isK5Dashboard,
} from 'utils/productHelpers'

import OffComponent from './flag.off'
import OnComponent from './flag.on'

export {
  DefaultSiteSelectorWrapper,
  SiteSelectorK8WrapperDark,
  SiteSelectorK8WrapperLight,
} from './component.styles'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: [
    'middle-school-june-release',
    'feature_LEARN-20108-ms-site-selection',
    'feature_LEARN-20164-k5-site-selection',
  ],
  OnComponent,
  OffComponent,
  flagsChecker: FlagsSingleton.checkAtLeastOneFlagTrue,
  onCondition: (_, subscribedFlags) => {
    // Check for high school context
    const isHighSchool = isHighSchoolUrl() || isHighSchoolDashboard()

    // Check for middle school context with feature flag enabled
    const isMiddleSchool =
      (isMiddleSchoolUrl() || isMiddleSchoolDashboard()) &&
      subscribedFlags['feature_LEARN-20108-ms-site-selection']

    // Check for K5 context with feature flag enabled
    const isK5 =
      (isK5Url() || isK5Dashboard()) &&
      subscribedFlags['feature_LEARN-20164-k5-site-selection']

    return isHighSchool || isMiddleSchool || isK5
  },
})

export default FlagToggler
